
  import {Component, Vue, Watch} from "vue-property-decorator";
  import DeviceStatus from "@/views/scanforacceptpacketgeton/deviceStatus.vue";
  import deviceItem from "@/views/scanforacceptpacketgeton/deviceItem";
  // import * as bindobject from "@/views/scanforacceptpacketgeton/bindobject";
  import {RankingList} from "@/views/components";
  import Scan2 from "@/views/components/Scan/Scan2.vue";
  import DeviceItems2 from "@/views/components/DeviceStatus/DeviceItems2.vue";
  import RankingList2 from "@/views/components/RankingList/RankingList2.vue";

  @Component({
    name: "scanforacceptpacketgeton",
    components: {RankingList2, DeviceItems2, Scan2, DeviceStatus, RankingList}
  })
  export default class extends Vue {
    @Watch("inputModel", {deep: true})
    oninputModelChange(val: string, oldVal: string) {
      this.asyncSendDataToNet(val);
    }

    //
    // async created() {
    //   // await CefSharp.BindObjectAsync("obj_ScanForAcceptPacketGetOn");
    //   //await bindobject.regist();
    // }

    //
    mounted() {
      //初始化设备状态
      this.deviceItems = [];
      for (let index = 1; index <= 12; index++) {
        this.deviceItems.push({
          name: "设备" + index.toString(),
          title: index.toString(),
          status: "defult"
        });
      }

      try {
        //注册设备状态回调函数
        obj_ScanForAcceptPacketGetOn.regist_getdevicestate(
          this.getdevicestatecallback
        );
        //注册历史数据回调函数
        obj_ScanForAcceptPacketGetOn.regist_datahistorycallback(
          this.datahistorycallback
        );
        obj_ScanForAcceptPacketGetOn.regist_errormsgcallback(
          this.errormsgcallback
        );
        obj_ScanForAcceptPacketGetOn.regist_sendformdata(this.sendformdata);
        obj_ScanForAcceptPacketGetOn.regist_updateformdata(this.scanareacallback);
        obj_ScanForAcceptPacketGetOn.regist_errormsgshowcallback(this.errormsgshowcallback);
        obj_ScanForAcceptPacketGetOn.regist_successmsgshowcallback(this.successmsgshowcallback);
      } catch (error) {
        console.log("error:" + "注册回调函数异常" + error);
      }

      var el = document.getElementById("input_scancode_id");
      this.selectElementContents(el);
      this.$nextTick(() => {
        this.sendformdata();
      });

      try {
        setTimeout(() => {
          obj_ScanForAcceptPacketGetOn.vueLoaded();
        }, 0.5 * 1000);
      } catch (error) {
        console.log("揽发合一界面加载完成调用失败" + error);
      }
    }

    beforeDestory() {
      // clearInterval(this.timer);
    }

    //线路查询
    private currentrowlinecodename = null;
    private cur_pagelinecodename = 1;
    private linecodenamepagination = 100;
    private linecodenameDialogFormVisible = false;
    private linecodenameform = {
      linecodename: ""
    };
    private tableDatalinecodename = [];
    //目的网点查询
    private currentrowdestinationorgcodename = null;
    private cur_pagedestinationorgcodename = 1;
    private destinationorgcodenamepagination = 100;
    private destinationorgcodenameDialogFormVisible = false;
    private destinationorgcodenameform = {
      destinationorgcodename: ""
    };
    private tableDatadestinationorgcodename = [];
    //收派员查询
    private currentrowpdausercodename = null;
    private cur_pagepdausercodename = 1;
    private pdausercodenamepagination = 100;
    private pdausercodenameDialogFormVisible = false;
    private pdausercodenameform = {
      pdausercodename: ""
    };
    private tableDatapdausercodename = [];
    private deviceItems: deviceItem[] = [];
    public list_LineData = [];
    public loading_DestinationOrg = false;
    public loading_LineData = false;
    public options = [];
    public ranklistdata: rankListModel = {
      avgEfficiency: "0",
      lastHourAvgEfficiency: "0",
      avgEfficiencyRank: "0",
      frequencyRank: "0",
      wholeTopEfficiency: "0"
    };
    private tableData = [
      // {
      //   index: "1",
      //   scancode: "2",
      //   carlabel: "3",
      //   nextorg: "4",
      //   destnation: "5",
      //   state: "重复",
      //   putinweight: "7",
      //   weighweight: "8",
      //   person: "9",
      //   custom: "0",
      //   scantime: "1",
      //   panelline: "2",
      //   message: "3",
      // },
    ];
    // private timer;
    // private pageopentime;
    // private pageopentimecount = 0;
    private inputModel: inputDataModel_AcceptPacketGetOn = {
      input_scancode: "",
      input_CarLabel: "",
      input_TrueThingCode: "",
      input_PanelLine: "",
      input_PanelLineNow: "",
      input_NextOrg: "",
      input_NextOrgNow: "",
      input_DestinationOrg: "",
      input_DestinationOrgNow: "",
      input_Person: "",
      input_PersonNow: "",
      input_Custom: "",
      input_CustomNow: "",
      input_weighweight: "0.0",
      input_putinweight: "0.0",
      input_DestinationOrgdisable: false,
      input_Persondisable: false,
      input_Customdisable: false,
      checked_DestinationOrgNow: false,
      checked_PersonNow: false,
      checked_CustomNow: false,
      checked_putinweight: false,
      checked_getorderdestnationorg: true,
      checked_voice: false,
      totalscancount: 0,
      piecescountincar: 0,
      totalweight: 0,
      position: "下车口1",
      list_DestinationOrg: [],
      putinweightdisable: false
      // options_Person: [
      //   {
      //     value: "",
      //     label: "",
      //   },
      // ],

      // options_DestinationOrg: [
      //   {
      //     value: "",
      //     label: "",
      //   },
      // ],
    };
    private options_NextOrg = [
      {
        value: "",
        label: ""
      }
    ];
    private mapStyle = {};
    private dashboardModel = {
      captureimage: "./img/1.jpg"
    };
    private tableData1 = [];
    private errormessage = "";
    private currentRow = null;
    private tableshow = true;

    public asyncSendDataToNet(data) {
      return new Promise(() => {
        obj_ScanForAcceptPacketGetOn.sendformdataaction(data);
      });
    }

    private pdausercodenameDialogFormOK(flag) {
      if (flag) {
        if (this.inputModel.checked_PersonNow == false) {
          this.inputModel.input_Person = this.currentrowpdausercodename.userCode;
          this.inputModel.input_PersonNow =
            this.currentrowpdausercodename.userCode +
            "|" +
            this.currentrowpdausercodename.userName;
        } else {
          this.messageboxShow("warning", "客户已被锁定，请先解锁");
        }
      }
      this.pdausercodenameDialogFormVisible = false;

      this.pdausercodenameform.pdausercodename = "";
    }

    private tablehandleCurrentChangepdausercodename(val) {
      this.currentrowpdausercodename = val;
    }

    private doubleclickselectpdausercodename(row) {
      this.pdausercodenameDialogFormVisible = false;
      if (this.inputModel.checked_PersonNow == false) {
        this.inputModel.input_Person = row.userCode;
        this.inputModel.input_PersonNow = row.userCode + "|" + row.userName;
      } else {
        this.messageboxShow("warning", "客户已被锁定，请先解锁");
      }
      this.pdausercodenameform.pdausercodename = "";
    }

    private searchpdausercodename() {
      obj_ScanForAcceptPacketGetOn.loadpdauser(
        10,
        1,
        this.pdausercodenameform.pdausercodename,
        this.initpdauser
      );
      this.cur_pagepdausercodename = 1;
    }

    private handleCurrentChangepdausercodename(val) {
      obj_ScanForAcceptPacketGetOn.loadpdauser(
        10,
        val,
        this.pdausercodenameform.pdausercodename,
        this.initpdauser
      );
    }

    public findpdausercodename() {
      this.pdausercodenameDialogFormVisible = true;
      obj_ScanForAcceptPacketGetOn.loadpdauser(
        10,
        1,
        this.pdausercodenameform.pdausercodename,
        this.initpdauser
      );
    }

    private destinationorgcodenameDialogFormOK(flag) {
      if (flag) {
        if (this.inputModel.checked_DestinationOrgNow == false) {
          this.inputModel.input_DestinationOrg = this.currentrowdestinationorgcodename.code;
          this.inputModel.input_DestinationOrgNow =
            this.currentrowdestinationorgcodename.code +
            "|" +
            this.currentrowdestinationorgcodename.name;
        } else {
          this.messageboxShow("warning", "目的网点已被锁定，请先解锁");
        }
      }
      this.destinationorgcodenameDialogFormVisible = false;
      this.destinationorgcodenameform.destinationorgcodename = "";
    }

    private tablehandleCurrentChangedestinationorgcodename(val) {
      this.currentrowdestinationorgcodename = val;
    }

    private doubleclickselectdestinationorgcodename(row) {
      this.destinationorgcodenameDialogFormVisible = false;
      if (this.inputModel.checked_DestinationOrgNow == false) {
        this.inputModel.input_DestinationOrg = row.code;
        this.inputModel.input_DestinationOrgNow = row.code + "|" + row.name;
      } else {
        this.messageboxShow("warning", "目的网点已被锁定，请先解锁");
      }
      this.destinationorgcodenameform.destinationorgcodename = "";
    }

    private handleCurrentChangedestinationorgcodename(val) {
      obj_ScanForAcceptPacketGetOn.loadorgcode(
        10,
        val,
        this.destinationorgcodenameform.destinationorgcodename,
        this.initorgcode
      );
    }

    private searchdestinationorgcodename() {
      obj_ScanForAcceptPacketGetOn.loadorgcode(
        10,
        1,
        this.destinationorgcodenameform.destinationorgcodename,
        this.initorgcode
      );
      this.cur_pagedestinationorgcodename = 1;
    }

    public finddestinationorgcodename() {
      this.destinationorgcodenameDialogFormVisible = true;
      obj_ScanForAcceptPacketGetOn.loadorgcode(10, 1, "", this.initorgcode);
    }

    private linecodenameDialogFormOK(flag) {
      if (flag) {
        this.inputModel.input_PanelLine = this.currentrowlinecodename.lineNo;
        this.inputModel.input_PanelLineNow =
          this.currentrowlinecodename.lineNo +
          "|" +
          this.currentrowlinecodename.transType +
          "|" +
          this.currentrowlinecodename.lineName;
        obj_ScanForAcceptPacketGetOn.getNextOrg(
          this.currentrowlinecodename.lineNo,
          this.currentrowlinecodename.lineName,
          this.getNextOrgCallback,
          this.scanareacallback
        );
      } else {
      }
      this.linecodenameDialogFormVisible = false;
      this.linecodenameform.linecodename = "";
    }

    private tablehandleCurrentChangelinecodename(val) {
      this.currentrowlinecodename = val;
    }

    private doubleclickselectlinecodename(row) {
      this.linecodenameDialogFormVisible = false;

      this.inputModel.input_PanelLine = row.lineNo;
      this.inputModel.input_PanelLineNow =
        row.lineNo + "|" + row.transType + "|" + row.lineName;

      this.inputModel.input_NextOrg = "";
      this.inputModel.input_NextOrgNow = "";
      this.options_NextOrg = [];

      obj_ScanForAcceptPacketGetOn.getNextOrg(
        row.lineNo,
        row.lineName,
        this.getNextOrgCallback,
        this.scanareacallback
      );
      this.linecodenameform.linecodename = "";
    }

    private handleCurrentChangelinecodename(val) {
      obj_ScanForAcceptPacketGetOn.loadlinedata(
        10,
        val,
        this.linecodenameform.linecodename,
        this.initlinedata
      );
    }

    private searchlinecodename() {
      obj_ScanForAcceptPacketGetOn.loadlinedata(
        10,
        1,
        this.linecodenameform.linecodename,
        this.initlinedata
      );
      this.cur_pagelinecodename = 1;
    }

    public findlinecodename() {
      this.linecodenameDialogFormVisible = true;
      obj_ScanForAcceptPacketGetOn.loadlinedata(10, 1, "", this.initlinedata);
    }

    private clearlinecodename() {
      this.inputModel.input_PanelLine = "";
      this.inputModel.input_PanelLineNow = "";
    }

    private putinweightnumberfunc(str) {
      try {
        if (isNaN(str)) {
          this.errormessage = "输入重数字输入错误，请重新输入";
          this.inputModel.input_putinweight = String(0);
          return;
        } else {
          var number = Number(str);
          this.inputModel.input_putinweight = String(number);
          this.errormessage = "";
        }
      } catch (error) {
        this.errormessage = "输入重数字输入错误，请重新输入";
      }
    }

    private handleCurrentChange(val) {
      this.currentRow = val;
    }

    //更新数据列表的数据
    public datahistorycallback(data) {
      this.tableData = data;

      if (data.length > 0 && this.inputModel.input_scancode == data[0].scancode) {
        this.inputModel.input_scancode = "";
      }
      var el = document.getElementById("input_scancode_id");
      this.selectElementContents(el);
    }

    //更新设备状态数据
    public getdevicestatecallback(datas): void {
      this.deviceItems = [];
      this.deviceItems = datas;
    }

    // //更新组织数据
    // public remoteMethod_loadorgcode(query): void {
    //   if (query !== "") {
    //     this.loading_DestinationOrg = true;
    //     setTimeout(() => {
    //       this.loading_DestinationOrg = false;
    //       obj_ScanForAcceptPacketGetOn.loadorgcode(query, this.initorgcode);
    //       this.options = this.inputModel.list_DestinationOrg.filter((item) => {
    //         return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
    //       });
    //     }, 2000);
    //   } else {
    //     this.options = [];
    //   }
    // }

    // //更新线路数据
    // public remoteMethod_loadlinedata(query): void {
    //   if (query !== "") {
    //     this.loading_LineData = true;
    //     setTimeout(() => {
    //       this.loading_LineData = false;
    //       obj_ScanForAcceptPacketGetOn.loadlinedata(query, this.initlinedata);
    //       this.options = this.list_LineData.filter((item) => {
    //         return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
    //       });
    //     }, 1000);
    //   } else {
    //     this.options = [];
    //   }
    // }

    //上传成功,为黑色，其他都是红色
    private rowClassAction(row) {
      if (/失败/.test(row.row.state)) {
        return {color: "#f22613", "font-size": "130%", "font-weight": "bold"};
      }
      if (/重复/.test(row.row.state)) {
        return {color: "#f22613", "font-size": "130%", "font-weight": "bold"};
      }
    }

    //输入重界面锁定方法
    private putinweightFunc() {
      if (this.inputModel.checked_putinweight == true) {
        this.inputModel.putinweightdisable = true;
      } else {
        this.inputModel.putinweightdisable = false;
      }
    }

    private DestinationNowcheckFunc() {
      if (this.inputModel.input_DestinationOrgNow == "") {
        this.errormessage = "当前目的网点为空，锁定无效";
        this.inputModel.checked_DestinationOrgNow = false;
      } else {
        if (this.inputModel.checked_DestinationOrgNow == true) {
          this.$confirm("锁定后目的地为同一个代码，锁定需谨慎！", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
            .then(() => {
              this.inputModel.input_DestinationOrgdisable = true;
            })
            .catch(() => {
              this.inputModel.checked_DestinationOrgNow = false;
            });
        } else {
          this.inputModel.input_DestinationOrgdisable = false;
        }
      }
    }

    private PersonNowcheckFunc() {
      if (this.inputModel.checked_PersonNow == true) {
        this.inputModel.input_Persondisable = true;
      } else {
        this.inputModel.input_Persondisable = false;
      }
    }

    private CustomNowLock() {
      if (this.inputModel.checked_CustomNow == true) {
        this.inputModel.input_Customdisable = true;
      } else {
        this.inputModel.input_Customdisable = false;
      }
    }

    //初始化用户
    private initpdauser(datas): void {
      var jsonobj = JSON.parse(datas);

      if (jsonobj.respcode == "000") {
        var allpersons = jsonobj.data.busiData.records;
        this.tableDatapdausercodename = allpersons;
        this.pdausercodenamepagination = jsonobj.data.busiData.total;
      } else {
        console.log(jsonobj);
      }
    }

    //初始化组织
    private initorgcode(datas): void {
      this.inputModel.list_DestinationOrg = [];
      var jsonobj = JSON.parse(datas);
      if (jsonobj.respcode == "000") {
        var allorgcodes = jsonobj.data.busiData.records;
        this.tableDatadestinationorgcodename = allorgcodes;
        this.destinationorgcodenamepagination = jsonobj.data.busiData.total;
      } else {
        console.log(jsonobj);
      }
    }

    //初始化线路
    private initlinedata(datas): void {
      this.list_LineData = [];
      var jsonobj = JSON.parse(datas);

      if (jsonobj.respcode == "000") {
        var alllinedata = jsonobj.data.busiData.records;
        this.tableDatalinecodename = alllinedata;
        this.linecodenamepagination = jsonobj.data.busiData.total;
      } else {
        console.log(jsonobj);
      }
    }

    //显示信息栏
    public messageboxShow(type, msg): void {
      // info
      // warning
      // success
      // error
      this.$message({
        message: msg,
        type: type
      });
    }

    //校验扫码输入条码
    public validateScanCode(code): boolean {
      console.log("|FUNC|校验输入条码");
      //校验关联交易号
      var reg = /^[A-Za-z0-9]{1,30}$/;
      if (!reg.test(code)) {
        // this.messageboxShow("success", "请输入字母或数字组成的单号");
        return false;
      }
      return true;
    }

    //选择寄件用户
    public checksendcustomernum(): void {
      if (this.inputModel.checked_CustomNow == true) {
        this.messageboxShow("warning", "客户已被锁定，请先解锁");
      } else {
        var sendcustomernum = this.inputModel.input_Custom;
        try {
          obj_ScanForAcceptPacketGetOn.getsendcustomernum(
            sendcustomernum,
            this.setsendcustomercallback
          );
        } catch (error) {
          console.log("error:" + "C#选择寄件客户");
        }
      }
    }

    //选择寄件客户回调
    public setsendcustomercallback(name): void {
      this.inputModel.input_CustomNow = name;
    }

    //获得焦点，选中文本
    private getInputFocus(event): void {
      event.currentTarget.select();
    }

    //扫描区扫码
    private Input_ScanArea_Click(scanCode) {
      scanCode = scanCode.toString();
      this.inputModel.input_scancode = scanCode.toUpperCase();
      try {
        obj_ScanForAcceptPacketGetOn.scanArea_Click(
          this.inputModel,
          this.scanareacallback
        );
      } catch (error) {
      }
      var el = document.getElementById("input_scancode_id");
      this.selectElementContents(el);
    }

    //错误消息回调显示方法
    public errormsgcallback(data) {
      this.errormessage = data;
    }

    //发送界面参数给C#
    public sendformdata() {
      obj_ScanForAcceptPacketGetOn.sendformdataaction(this.inputModel);
    }

    //界面参数更新方法
    private scanareacallback(backdata): void {
      this.inputModel.input_scancode = "";
      if (backdata == null) {
        return;
      }
      //更新录入区域
      //更新车签
      if (
        backdata.input_CarLabel != null &&
        backdata.input_CarLabel != this.inputModel.input_CarLabel
      ) {
        this.inputModel.input_CarLabel = backdata.input_CarLabel;
      }
      //更新实物条码
      if (
        backdata.input_TrueThingCode != null &&
        this.inputModel.input_TrueThingCode != backdata.input_TrueThingCode
      ) {
        this.inputModel.input_TrueThingCode = backdata.input_TrueThingCode;
      }
      //更新线路
      if (
        backdata.input_PanelLine != null &&
        this.inputModel.input_PanelLine != backdata.input_PanelLine
      ) {
        this.inputModel.input_PanelLine = backdata.input_PanelLine;
      }
      //更新线路now
      if (
        backdata.input_PanelLineNow != null &&
        this.inputModel.input_PanelLineNow != backdata.input_PanelLineNow
      ) {
        this.inputModel.input_PanelLineNow = backdata.input_PanelLineNow;
      }
      //更新下一网点
      if (
        backdata.input_NextOrg != null &&
        this.inputModel.input_NextOrg != backdata.input_NextOrg
      ) {
        this.inputModel.input_NextOrg = backdata.input_NextOrg;
      }
      //更新下一网点now
      if (
        backdata.input_NextOrgNow != null &&
        this.inputModel.input_NextOrgNow != backdata.input_NextOrgNow
      ) {
        this.inputModel.input_NextOrgNow = backdata.input_NextOrgNow;
      }
      //更新目的网点
      if (
        backdata.input_DestinationOrg != null &&
        this.inputModel.input_DestinationOrg != backdata.input_DestinationOrg
      ) {
        if (this.inputModel.checked_DestinationOrgNow == false) {
          this.inputModel.input_DestinationOrg = backdata.input_DestinationOrg;
        } else {
          this.messageboxShow(
            "warning",
            "后台数据修改目的网点，但已锁定，如需修改，请先解除锁定！"
          );
        }
      }
      //更新目的网点now
      if (
        backdata.input_DestinationOrgNow != null &&
        this.inputModel.input_DestinationOrgNow !=
        backdata.input_DestinationOrgNow
      ) {
        if (this.inputModel.checked_DestinationOrgNow == false) {
          this.inputModel.input_DestinationOrgNow =
            backdata.input_DestinationOrgNow;
        } else {
          this.messageboxShow(
            "warning",
            "后台数据修改目的网点，但已锁定，如需修改，请先解除锁定！"
          );
        }
      }
      //更新收派员
      if (
        backdata.input_Person != null &&
        this.inputModel.input_Person != backdata.input_Person
      ) {
        if (this.inputModel.checked_PersonNow == false) {
          this.inputModel.input_Person = backdata.input_Person;
        } else {
          this.messageboxShow(
            "warning",
            "后台数据修改收派员，但已锁定，如需修改，请先解除锁定！"
          );
        }
      }
      //更新收派员路now
      if (
        backdata.input_PersonNow != null &&
        this.inputModel.input_PersonNow != backdata.input_PersonNow
      ) {
        if (this.inputModel.checked_PersonNow == false) {
          this.inputModel.input_PersonNow = backdata.input_PersonNow;
        } else {
          this.messageboxShow(
            "warning",
            "后台数据修改收派员，但已锁定，如需修改，请先解除锁定！"
          );
        }
      }
      //更新寄件客户
      if (
        backdata.input_Custom != null &&
        this.inputModel.input_Custom != backdata.input_Custom
      ) {
        if (this.inputModel.checked_CustomNow == false) {
          this.inputModel.input_Custom = backdata.input_Custom;
        } else {
          this.messageboxShow(
            "warning",
            "后台数据修改寄件客户，但已锁定，如需修改，请先解除锁定！"
          );
        }
      }
      //更新寄件客户now
      if (
        backdata.input_CustomNow != null &&
        this.inputModel.input_CustomNow != backdata.input_CustomNow
      ) {
        if (this.inputModel.checked_CustomNow == false) {
          this.inputModel.input_CustomNow = backdata.input_CustomNow;
        } else {
          this.messageboxShow(
            "warning",
            "后台数据修改寄件客户，但已锁定，如需修改，请先解除锁定！"
          );
        }
      }
      //更新称入重
      if (
        backdata.input_weighweight != null &&
        this.inputModel.input_weighweight != backdata.input_weighweight
      ) {
        this.inputModel.input_weighweight = backdata.input_weighweight;
      }
      //更新输入重
      if (
        backdata.input_putinweight != null &&
        this.inputModel.input_putinweight != backdata.input_putinweight
      ) {
        if (this.inputModel.checked_putinweight == false) {
          this.inputModel.input_putinweight = backdata.input_putinweight;
        } else {
          this.messageboxShow(
            "warning",
            "后台数据修改输入重，但已锁定，如需修改，请先解除锁定！"
          );
        }
      }
      //更新扫描条码
      if (
        backdata.input_scancode != null &&
        this.inputModel.input_scancode != backdata.input_scancode
      ) {
        this.inputModel.input_scancode = backdata.input_scancode;
      }
      //更新显示区域
      //更新总扫描数
      if (
        backdata.totalscancount != null &&
        this.inputModel.totalscancount != backdata.totalscancount
      ) {
        this.inputModel.totalscancount = backdata.totalscancount;
      }
      //更新车内件数
      if (
        backdata.piecescountincar != null &&
        this.inputModel.piecescountincar != backdata.piecescountincar
      ) {
        this.inputModel.piecescountincar = backdata.piecescountincar;
      }
      //更新累计重量
      if (
        backdata.totalweight != null &&
        this.inputModel.totalweight != backdata.totalweight
      ) {
        this.inputModel.totalweight = backdata.totalweight;
      }
      var el = document.getElementById("input_scancode_id");
      this.selectElementContents(el);
    }

    public selectElementContents(el) {
      //失去焦点，获取焦点
      el.blur();
      el.focus();
    }

    //下一网点选择
    private chooseNextOrgCode(item): void {
      this.inputModel.input_NextOrgNow = item.value + "|" + item.label;
    }

    //下一网点界面更新判定
    private getNextOrgCallback(datas) {
      this.inputModel.input_NextOrgNow =
        datas.nextOrgCode + "|" + datas.nextOrgName;
      var jsonobj = JSON.parse(datas.result);
      if (jsonobj.data.busiDataArray != null) {
        this.options_NextOrg = [];
        jsonobj.data.busiDataArray.forEach(element => {
          this.options_NextOrg.push({
            label: element.endOrgName,
            value: element.endOrgCode
          });
        });
        this.inputModel.input_NextOrg = this.options_NextOrg[0].value;
      }
    }

    private deleterowdata() {
      if (this.currentRow == null) {
        this.messageboxShow("warning", "请先选择要删除的数据");
        return;
      }

      this.$confirm("是否确定要删除此数据？", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          console.log("执行删除以下数据的动作");
          console.log(this.currentRow);
          try {
            obj_ScanForAcceptPacketGetOn.deletedatahistory(this.currentRow);
          } catch (error) {
            console.log("删除失败：" + error.message);
          }
          this.currentRow = null;
        })
        .catch(() => {
          console.log("取消删除");
        });
    }

    private errormsgshowcallback(msg) {
      this.$message.error(msg)
    }

    private successmsgshowcallback(msg) {
      this.$message.success(msg)
    }
  }
